import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function DashboardCoordinateur() {
  const [user, setUser] = useState(null);
  const [projets, setProjets] = useState([]);
  const [devis, setDevis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [onglet, setOnglet] = useState('overview');
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem('user');
    const token = localStorage.getItem('token');

    if (!userData || !token) {
      navigate('/login');
      return;
    }

    const u = JSON.parse(userData);
    if (u.role !== 'coordinateur') {
      navigate('/login');
      return;
    }

    setUser(u);
    chargerDonnees(token);
  }, [navigate]);

  const chargerDonnees = async (token) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const projetsRes = await axios.get('https://efe-systems.com/api/projets', { headers });
      const projetsData = projetsRes.data.data || projetsRes.data;
      setProjets(Array.isArray(projetsData) ? projetsData : []);
    } catch (error) {
      console.error('Erreur:', error);
      setProjets([]);
    } finally {
      setLoading(false);
    }
  };

  const deconnexion = async () => {
    const token = localStorage.getItem('token');
    try {
      await axios.post('https://efe-systems.com/api/logout', {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (e) {}
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const statutConfig = {
    'en_attente':  { label: 'En attente',   couleur: '#F5C500', bg: 'rgba(245,197,0,0.12)',   icone: '⏳' },
    'en_cours':    { label: 'En cours',      couleur: '#1A1AE6', bg: 'rgba(26,26,230,0.12)',   icone: '🔄' },
    'phase_test':  { label: 'Phase test',    couleur: '#6B21E8', bg: 'rgba(107,33,232,0.12)',  icone: '🧪' },
    'en_revision': { label: 'En révision',   couleur: '#0EA5E9', bg: 'rgba(14,165,233,0.12)',  icone: '✏️' },
    'livre':       { label: 'Livré',         couleur: '#10B981', bg: 'rgba(16,185,129,0.12)',  icone: '✅' },
    'archive':     { label: 'Archivé',       couleur: '#6B7280', bg: 'rgba(107,114,128,0.12)', icone: '📦' },
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#f8f9ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="text-center">
          <div className="text-4xl mb-4">⚡</div>
          <p style={{ color: '#1A1AE6', fontWeight: '600' }}>Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9ff' }}>
      <Navbar />

      {/* Header */}
      <div style={{ background: '#050510', paddingTop: '80px' }}>
        <div className="max-w-6xl mx-auto px-6 py-10">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-400 text-sm mb-1">Espace Coordinateur</p>
              <h1 className="text-3xl font-extrabold text-white">
                Bonjour, <span style={{ color: '#F5C500' }}>{user?.prenom} {user?.nom}</span> 📋
              </h1>
              <p className="text-gray-400 mt-1 text-sm">Vue globale de tous les projets</p>
            </div>
            <div className="flex gap-3">
              <Link
                to="/changer-mot-de-passe"
                className="px-4 py-2 rounded-xl text-sm font-semibold transition hover:opacity-80"
                style={{ background: 'rgba(255,255,255,0.08)', color: 'white', border: '1px solid rgba(255,255,255,0.15)', textDecoration: 'none' }}
              >
                🔑 Changer mot de passe
              </Link>
              <button
                onClick={deconnexion}
                className="px-4 py-2 rounded-xl text-sm font-semibold transition hover:opacity-80"
                style={{ background: 'rgba(239,68,68,0.15)', color: '#EF4444', border: '1px solid rgba(239,68,68,0.3)' }}
              >
                Déconnexion
              </button>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
            {[
              { label: 'Projets total',  valeur: projets.length,                                         icone: '📁', couleur: '#1A1AE6' },
              { label: 'En cours',       valeur: projets.filter(p => p.statut === 'en_cours').length,    icone: '🔄', couleur: '#F5C500' },
              { label: 'Livrés',         valeur: projets.filter(p => p.statut === 'livre').length,       icone: '✅', couleur: '#10B981' },
              { label: 'En attente',     valeur: projets.filter(p => p.statut === 'en_attente').length,  icone: '⏳', couleur: '#6B21E8' },
            ].map((stat, i) => (
              <div key={i} className="rounded-2xl p-4 text-center"
                style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}>
                <div className="text-2xl mb-1">{stat.icone}</div>
                <p className="text-2xl font-extrabold" style={{ color: stat.couleur }}>{stat.valeur}</p>
                <p className="text-gray-400 text-xs mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div className="max-w-6xl mx-auto px-6 py-10">

        {/* Onglets */}
        <div className="flex gap-2 mb-8">
          {[
            { id: 'overview', label: '📊 Vue globale' },
            { id: 'projets',  label: '📁 Tous les projets' },
            { id: 'rapports', label: '📝 Rapports' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setOnglet(tab.id)}
              className="px-5 py-2 rounded-xl text-sm font-semibold transition"
              style={{
                background: onglet === tab.id ? '#1A1AE6' : 'white',
                color: onglet === tab.id ? 'white' : '#6B7280',
                border: `1px solid ${onglet === tab.id ? '#1A1AE6' : 'rgba(0,0,0,0.08)'}`,
                boxShadow: onglet === tab.id ? '0 4px 15px rgba(26,26,230,0.3)' : 'none',
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Vue globale */}
        {onglet === 'overview' && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="rounded-2xl p-6 bg-white"
              style={{ border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 15px rgba(0,0,0,0.05)' }}>
              <h3 className="font-bold text-lg mb-4" style={{ color: '#0F0F2D' }}>📁 Derniers projets</h3>
              {projets.length === 0 ? (
                <p className="text-gray-400 text-sm">Aucun projet pour le moment</p>
              ) : (
                projets.slice(0, 5).map((projet, i) => {
                  const statut = statutConfig[projet.statut] || { label: projet.statut, couleur: '#6B7280', bg: 'rgba(107,114,128,0.1)', icone: '📋' };
                  return (
                    <div key={i} className="flex items-center justify-between py-3"
                      style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <div>
                        <p className="font-medium text-sm" style={{ color: '#0F0F2D' }}>{projet.titre}</p>
                        <p className="text-gray-400 text-xs">{projet.client?.prenom} {projet.client?.nom}</p>
                      </div>
                      <span className="px-2 py-1 rounded-full text-xs font-bold flex items-center gap-1"
                        style={{ background: statut.bg, color: statut.couleur }}>
                        {statut.icone} {statut.label}
                      </span>
                    </div>
                  );
                })
              )}
            </div>

            {/* Répartition par statut */}
            <div className="rounded-2xl p-6 bg-white"
              style={{ border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 15px rgba(0,0,0,0.05)' }}>
              <h3 className="font-bold text-lg mb-4" style={{ color: '#0F0F2D' }}>📊 Répartition des projets</h3>
              {Object.entries(statutConfig).map(([key, statut]) => {
                const count = projets.filter(p => p.statut === key).length;
                if (count === 0) return null;
                return (
                  <div key={key} className="flex items-center justify-between py-2">
                    <span className="text-sm flex items-center gap-2" style={{ color: '#6B7280' }}>
                      {statut.icone} {statut.label}
                    </span>
                    <span className="px-3 py-1 rounded-full text-xs font-bold"
                      style={{ background: statut.bg, color: statut.couleur }}>
                      {count}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Tous les projets */}
        {onglet === 'projets' && (
          <div className="flex flex-col gap-4">
            {projets.length === 0 ? (
              <div className="text-center py-20 rounded-3xl bg-white"
                style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
                <p className="text-5xl mb-4">📁</p>
                <p className="font-bold text-xl" style={{ color: '#0F0F2D' }}>Aucun projet pour le moment</p>
              </div>
            ) : (
              projets.map((projet, index) => {
                const statut = statutConfig[projet.statut] || { label: projet.statut, couleur: '#6B7280', bg: 'rgba(107,114,128,0.1)', icone: '📋' };
                return (
                  <div key={index} className="rounded-2xl bg-white overflow-hidden transition hover:shadow-lg"
                    style={{ border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 15px rgba(0,0,0,0.05)' }}>
                    <div className="h-1.5 w-full" style={{ background: statut.couleur }}></div>
                    <div className="p-6">
                      <div className="flex items-start justify-between mb-4">
                        <div>
                          <h3 className="font-extrabold text-xl mb-1" style={{ color: '#0F0F2D' }}>{projet.titre}</h3>
                          <p className="text-gray-500 text-sm mb-1">{projet.description}</p>
                          <p className="text-gray-400 text-xs">
                            👤 {projet.client?.prenom} {projet.client?.nom}
                          </p>
                        </div>
                        <span className="px-3 py-1.5 rounded-full text-xs font-bold flex-shrink-0 ml-4 flex items-center gap-1"
                          style={{ background: statut.bg, color: statut.couleur }}>
                          {statut.icone} {statut.label}
                        </span>
                      </div>
                      <div className="mb-4">
                        <div className="flex justify-between text-xs mb-1.5" style={{ color: '#6B7280' }}>
                          <span>Progression</span>
                          <span className="font-bold" style={{ color: statut.couleur }}>{projet.progression || 0}%</span>
                        </div>
                        <div className="rounded-full h-3" style={{ background: '#f0f0f0' }}>
                          <div className="h-3 rounded-full transition-all duration-500"
                            style={{ width: `${projet.progression || 0}%`, background: statut.couleur }}>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-wrap gap-4 text-xs" style={{ color: '#9CA3AF' }}>
                        {projet.date_debut && <span>📅 {new Date(projet.date_debut).toLocaleDateString('fr-FR')}</span>}
                        {projet.date_livraison_prevue && <span>🎯 {new Date(projet.date_livraison_prevue).toLocaleDateString('fr-FR')}</span>}
                        {projet.montant_total && <span>💰 {projet.montant_total} $</span>}
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        )}

        {/* Rapports */}
        {onglet === 'rapports' && (
          <div className="text-center py-20 rounded-3xl bg-white"
            style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
            <p className="text-5xl mb-4">📝</p>
            <p className="font-bold text-xl mb-2" style={{ color: '#0F0F2D' }}>Rapports à venir</p>
            <p className="text-gray-400 text-sm">La validation des rapports sera disponible prochainement.</p>
          </div>
        )}

      </div>

      <Footer />
    </div>
  );
}

export default DashboardCoordinateur;